import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { topics } from "@/mocks/topics";

const friendLinks = [
  { label: "中国电影网", href: "https://www.chinafilm.com" },
  { label: "音乐周刊", href: "https://tailvsc.cn" },
  { label: "潮流志", href: "https://tailvsc.cn" },
  { label: "城市生活指南", href: "https://tailvsc.cn" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-background-50">
                噜
              </span>
              <span className="text-lg font-extrabold text-foreground-950">噜噜社</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              噜噜社是一个综合娱乐资讯与潮流文化平台，聚合音乐、影视、时尚与潮流文化的及时内容与深度专题。
            </p>
            <div className="mt-4 flex items-center gap-3 text-xl text-foreground-500">
              <a href="https://weibo.com" target="_blank" rel="noreferrer" aria-label="微博" className="cursor-pointer transition-colors hover:text-primary-500">
                <i className="ri-weibo-fill" />
              </a>
              <a href="https://www.douyin.com" target="_blank" rel="noreferrer" aria-label="抖音" className="cursor-pointer transition-colors hover:text-primary-500">
                <i className="ri-tiktok-fill" />
              </a>
              <a href="https://www.xiaohongshu.com" target="_blank" rel="noreferrer" aria-label="小红书" className="cursor-pointer transition-colors hover:text-primary-500">
                <i className="ri-book-marked-fill" />
              </a>
              <a href="https://www.bilibili.com" target="_blank" rel="noreferrer" aria-label="哔哩哔哩" className="cursor-pointer transition-colors hover:text-primary-500">
                <i className="ri-play-circle-fill" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-foreground-950">内容分类</h4>
            <ul className="mt-4 flex flex-col gap-2">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-500"
                  >
                    {c.name}资讯
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-foreground-950">精选专题</h4>
            <ul className="mt-4 flex flex-col gap-2">
              {topics.map((t) => (
                <li key={t.id}>
                  <Link
                    to={`/topic/${t.id}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-500"
                  >
                    {t.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-foreground-950">关于与联系</h4>
            <ul className="mt-4 flex flex-col gap-2 text-sm text-foreground-600">
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-500">
                  关于噜噜社
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-primary-500">
                  搜索全站内容
                </Link>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500" />
                hello@lulushe.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-500" />
                400-889-2026
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">© 2026 噜噜社 LULU CLUB · 保留所有权利 · 本站内容为演示用途</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
            <span className="text-foreground-400">友情链接</span>
            {friendLinks.map((l) => (
              <a key={l.label} href={l.href} target="_blank" rel="noreferrer" className="transition-colors hover:text-primary-500">
                {l.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}